import Tdg_OrganisationListModelBase from '../_generated/modelBases/tdg-organisation-list-model-base';

export default class Tdg_OrganisationListModel extends Tdg_OrganisationListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
